import React, { useEffect } from 'react'
import { AutocompleteAnalyticsData } from './algolia'
import { promotionsIndex } from './algoliaSearchConfig'

type PromoBannerProps = {
  title: string
  subtitle: string
  href: string
  onClick?: () => void
  objectIDs: Array<{ object_id: string; suggestion_value: string }>
  queryID?: string
  sendAutoCompleteAnalyticsEvent: (eventData: AutocompleteAnalyticsData) => void
  isOpen: boolean
}

export const PromoBanner: React.FC<PromoBannerProps> = ({
  title,
  subtitle,
  href,
  onClick,
  objectIDs,
  queryID,
  sendAutoCompleteAnalyticsEvent,
  isOpen,
}) => {
  const sentEventRef = React.useRef(false)

  useEffect(() => {
    if (!isOpen || sentEventRef.current) return

    sendAutoCompleteAnalyticsEvent({
      topic: 'promo',
      objectIDs,
      queryID,
      type: 'view',
      state: 'empty',
    })

    window.aa?.('viewedObjectIDs', {
      eventType: 'view',
      eventName: 'Promotion shown',
      index: promotionsIndex,
      objectIDs: objectIDs.map((obj) => obj.object_id),
    })

    sentEventRef.current = true
  }, [isOpen, sendAutoCompleteAnalyticsEvent])

  return (
    <a
      href={href}
      onClick={() => {
        sendAutoCompleteAnalyticsEvent({
          topic: 'promo',
          objectIDs,
          queryID,
          type: 'click',
          state: 'empty',
        })
        window.aa?.('clickedObjectIDsAfterSearch', {
          eventType: 'click',
          eventName: 'Promotion clicked',
          index: promotionsIndex,
          objectIDs: [objectIDs?.[0]?.object_id],
          queryID: queryID ?? '',
          positions: [1],
        })
        onClick?.()
      }}
      className="block rounded-[10px] border border-[#ffd200] bg-[#fff7cc] px-3 md:px-6 py-3 text-left shadow-sm"
    >
      <div className="flex items-center gap-4">
        {/* Icona circolare a sinistra */}
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#ffd200] text-base font-bold shrink-0">
          %
        </div>

        {/* Testi */}
        <div className="flex flex-col">
          <span className="text-[10px] font-semibold uppercase tracking-[0.08em] text-gray-600 mb-2">
            Promo della settimana
          </span>
          <span className="text-sm font-bold text-black leading-tight mb-1">
            {title}
          </span>
          <span className="text-[11px] text-gray-700 leading-snug">
            {subtitle}
          </span>
        </div>
      </div>
    </a>
  )
}
